import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* chargeTypeDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_DELETE_REQUEST
    });

    yield call(Http.delete, `charge-type/${action.payload?.chargeType.id}`);

    yield put({
      type: Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_DELETE_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-type-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeTypeDelete() {
  yield takeEvery(Constants.GLOBAL_CHARGE_TYPE_DELETE_START, chargeTypeDelete);
}
